/**
 * Umami Analytics utility functions
 * Provides type-safe event tracking for Umami Analytics
 */

/**
 * Track a custom event in Umami Analytics
 * Non-blocking: If Umami is unavailable, tracking silently fails without affecting the app
 * @param eventName - Name of the event (e.g., 'nav-home', 'product-view-prodevs')
 * @param eventData - Optional event data object with key-value pairs
 */
export const trackEvent = (eventName: string, eventData?: Record<string, string>): void => {
  // Early return if not in browser environment
  if (typeof window === 'undefined') {
    return;
  }

  // Check if Umami is loaded and available
  if (!window.umami || typeof window.umami.track !== 'function') {
    // Silently fail - analytics server may be down, but app continues normally
    return;
  }

  try {
    window.umami.track(eventName, eventData);
  } catch (error) {
    // Silently fail in production, log in development
    // This ensures analytics failures never break the application
    if (import.meta.env.DEV) {
      console.warn('Umami tracking error (non-blocking):', error);
    }
  }
};

/**
 * Check if Umami is available
 */
export const isUmamiAvailable = (): boolean => {
  return typeof window !== 'undefined' && typeof window.umami !== 'undefined';
};

